module.exports = __webpack_public_path__ + "img/spinner.8ab7e767.gif";